import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import router from './router'
import store from './store'
import './assets/iconfonts/iconfont.css'
import 'lib-flexible/flexible'

Vue.config.productionTip = false
Vue.use(Vant)

// import * as Sentry from "@sentry/vue";
// import { BrowserTracing } from "@sentry/tracing";
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// Init plugin
// Vue.use(Loading);
Vue.use(Loading, {
  // props
  color: 'blue',
  loader: 'spinner',
  width: 64,
  height: 64,
  backgroundColor: '#ffffff',
  opacity: 0.5,
  zIndex: 999,
}, {
  // slots
})

import * as echarts from 'echarts';
// import echarts from "echarts";
console.log(echarts)
Vue.prototype.$echarts = echarts;

// Sentry.init({
//   Vue,
//   dsn: "http://dcf11e2e18da45acaf7ba492f5ab3d56@218.58.76.102:19110/12",
//   integrations: [
//     new BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: ["localhost", "share.bondex.com.cn:14884/", /^\//],
//     }),
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });

// Sentry.captureMessage('APP Start', 'log')

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
